import {
  parseEligibleProductsList,
  parseProductFeatures
} from 'product-features/productAssetsParser';
import {
  setEligibleProducts,
  setProductFeaturesByFieldUuid
} from 'product-features';

export const processEligibleProducts = async ({ dispatch, rawEligibleProducts }) => {
  const eligibleProducts = parseEligibleProductsList(rawEligibleProducts);
  dispatch(setEligibleProducts({eligibleProducts}));
  return eligibleProducts;
};

export const processProductFeaturesForField = async ({ dispatch, rawProductFeatures }) => {
  const productFeatures = parseProductFeatures(rawProductFeatures);
  dispatch(setProductFeaturesByFieldUuid(productFeatures));
  return productFeatures;
};
